import { AnalysisResult } from "@/redux/feature/videoDashboard/videoDashboardType";
import { Zap } from "lucide-react";

const TechnicalAnalysis: React.FC<{
  data: AnalysisResult["technical_analysis"];
}> = ({ data }) => (
  <div className="bg-white rounded-lg border border-gray-200 p-6">
    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
      <Zap className="w-5 h-5" />
      Technical Analysis
    </h3>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-4">
        <div>
          <span className="text-sm font-medium text-gray-900">
            Physical Setting
          </span>
          <p className="text-sm text-gray-600 mt-1 capitalize">
            {data.physical_setting.replace("_", " ")}
          </p>
        </div>
        <div>
          <span className="text-sm font-medium text-gray-900">Ad Format</span>
          <p className="text-sm text-gray-600 mt-1 capitalize">
            {data.ad_format.replace("_", " ")}
          </p>
        </div>
        <div>
          <span className="text-sm font-medium text-gray-900">Eye Contact</span>
          <p className="text-sm text-gray-600 mt-1">
            {data.eye_contact_percent}%
          </p>
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <span className="text-sm font-medium text-gray-900">
            Visual Clarity
          </span>
          <p className="text-sm text-gray-600 mt-1">
            {data.visual_clarity_score}/5
          </p>
        </div>
        <div>
          <span className="text-sm font-medium text-gray-900">Pacing</span>
          <p className="text-sm text-gray-600 mt-1">
            {data.pacing_median_seconds}s median
          </p>
        </div>
        <div>
          <span className="text-sm font-medium text-gray-900">
            Text Overlay
          </span>
          <p className="text-sm text-gray-600 mt-1">
            {data.early_text_overlay}
          </p>
        </div>
      </div>
    </div>

    <div className="mt-6">
      <span className="text-sm font-medium text-gray-900">Storyline</span>
      <p className="text-sm text-gray-600 mt-2 leading-relaxed">
        {data.storyline}
      </p>
    </div>
  </div>
);

export default TechnicalAnalysis;
